"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ModalHeaderTabs", {
    enumerable: true,
    get: function() {
        return ModalHeaderTabs;
    }
});
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _SelectedContext = require("../../../contexts/SelectedContext");
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const ModalHeaderTabs = (param)=>{
    let { children, defaultTab, onSelect } = param;
    const [selectedTab, setSelectedTab] = (0, _react.useState)(defaultTab);
    (0, _react.useEffect)(()=>{
        if (onSelect != null) {
            onSelect(selectedTab);
        }
    }, [
        onSelect,
        selectedTab
    ]);
    return /*#__PURE__*/ _react.default.createElement("div", {
        className: "d-flex"
    }, /*#__PURE__*/ _react.default.createElement(_SelectedContext.SelectedContext.Provider, {
        value: {
            selected: selectedTab,
            setSelected: setSelectedTab
        }
    }, children));
};

//# sourceMappingURL=ModalHeaderTabs.js.map